import React from "react";
import IMG1 from "../../assets/movie-recommend.png";
import IMG2 from "../../assets/social_sphere.png";
import IMG3 from "../../assets/explore_world.png";
import IMG4 from "../../assets/cine-flix.png";
import IMG5 from "../../assets/furniture_home.png";
import IMG6 from "../../assets/resort_home.png";
import IMG7 from "../../assets/tourism_home.png";
import IMG8 from "../../assets/hotel_home.png";

import "./portfolio.css";

const Portfolio = () => {
  const soloProjects = [
    {
      id: 1,
      title: "Movie Recommender System",
      img: IMG1,
      description: `personalized movie suggestions based
        on user preferences and search. Users can input a movie title and model recommends movies based on content-based filtering algorithms which delivers impressive 97% accuracy.`,
      technologies: "Python | Scikit-learn | Pandas | Numpy | AJAX",
      link: "https://drive.google.com/drive/folders/1tKRB2Um1pqyqkHXwUGqqCknpuTdVol-S?usp=drive_link",
      github: "https://github.com/kujwal710329/Movie-Recommendation-System",
    },
    {
      id: 2,
      title: "Social Media Platform",
      img: IMG2,
      description: `Social Media Platform, features include post creation, like and comment
      functionalities, friend list management, and personalized profile pages. Signup and login features for personalised feed.`,
      technologies: "React | Redux | Node | MaterialUI | MongoDB",
      link: "https://atsocialsphere.vercel.app/",
      github: "https://github.com/kujwal710329/social-sphere",
    },
    {
      id: 3,
      title: "Tour Management System",
      img: IMG3,
      description: `Tour Management System, features include user-friendly Admin panel, tour guide assignment, and update tours. Users can search tours and book tours with secure payment processing.`,
      technologies: "Node | MondoDB | JavaScript | HTML5 | CSS3",
      link: "https://explore-world.onrender.com/",
      github: "https://github.com/kujwal710329/Explore-world",
    },
    {
      id: 4,
      title: "Cine-Flix",
      img: IMG4,
      description: "Movie Listing website which lists movies and shows deatils about each movies.",
      technologies: "React | Node | MongoDB | HTML5 | CSS3",
      link: "https://watch-cineflix.vercel.app/",
      github: "https://github.com/kujwal710329/CineFlix",
    },

    {
      id: 5,
      title: "Furniture-shop",
      img: IMG5,
      description: `The world's most loved home furnishing store, now at your fingertips.
      learning the UI design`,
      technologies: "HTML5 | CSS3",
      link: "https://drive.google.com/drive/folders/1tKRB2Um1pqyqkHXwUGqqCknpuTdVol-S?usp=drive_link",
      github: "https://github.com/kujwal710329/Furniture-shop",
    },
    {
      id: 6,
      title: "river-front-resort",
      img: IMG6,
      description: `Redefines the luxury hospitality experience.`,
      technologies: "HTML5 | CSS3",
      link: "https://drive.google.com/drive/folders/1tKRB2Um1pqyqkHXwUGqqCknpuTdVol-S?usp=drive_link",
      github: "https://github.com/kujwal710329/river-front-resort/",
    },
    {
      id: 7,
      title: "tourism-website",
      img: IMG7,
      description: `TRIP YOUR DREAM ADVENTURE. Travel and Love the world!`,
      technologies: "React | HTML5 | CSS3",
      link: "https://drive.google.com/drive/folders/1tKRB2Um1pqyqkHXwUGqqCknpuTdVol-S?usp=drive_link",
      github: "https://github.com/kujwal710329/tourism-website",
    },
    {
      id: 8,
      title: "Hotel-website",
      img: IMG8,
      description: `Book Cheap, Budget and Luxury Hotels`,
      technologies: "React |Redux | Node | MongoDB | HTML5 | CSS3",
      link: "https://drive.google.com/drive/folders/1tKRB2Um1pqyqkHXwUGqqCknpuTdVol-S?usp=drive_link",
      github: "https://github.com/kujwal710329/hotel-booking",
    },
  ];

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {soloProjects.map((pro) => (
          <article className="portfolio__item" key={pro.id}>
            <div className="portfolio__item-image">
              <img src={pro.img} alt={pro.title} />
            </div>
            <div className="portfolio__item-content">
              <h3>{pro.title}</h3>
              <p>{pro.description}</p>
              <p className="portfolio_tech">{pro.technologies}</p>
            </div>
            <div className="portfolio__item-cta">
              <a href={pro.github} target="_blank" className="btn" rel="noreferrer">
                GitHub
              </a>
              <a href={pro.link} target="_blank" className="btn btn-primary" rel="noreferrer">
                Visit Website
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
